export interface ActionType{
  title: string;
  tipo: string;
}

export const UPDATE:ActionType = {
  title:"Editar Parte",
  tipo:"U"
}

export const CREATE: ActionType = {
  title:"Crear Parte",
  tipo:"I"
}

export const ADJUNTAR: ActionType = {
  title:"Adjuntar archivos",
  tipo:"A"
}

export const VALIDAR: ActionType = {
  title:"Validar Partes",
  tipo:"V"
}

export const ESTADOS = {
  RESPONSABLE_AREA: {codEstado:1,tipoVal:'RAR',tipoDesv:''},
  FISCAL: {codEstado:2,tipoVal:'FIS',tipoDesv:'RAR'},
  FACTURACION: {codEstado:3,tipoVal:'FAC',tipoDesv:'FIS'},
  FACTURADO: {codEstado:4,tipoVal:'',tipoDesv:'FAC'},
  TODOS: {codEstado:5,tipoVal:''}
}

export const USER_PERMISSIONS = {
  'USR':{
    'adjuntar': [ESTADOS.RESPONSABLE_AREA.codEstado],
    'editar': [ESTADOS.RESPONSABLE_AREA.codEstado],
    'validar': [],
    'desvalidar': []
  },
  'RAR':{
    'adjuntar': [ESTADOS.RESPONSABLE_AREA.codEstado],
    'editar': [ESTADOS.RESPONSABLE_AREA.codEstado],
    'validar': [ESTADOS.RESPONSABLE_AREA.codEstado],
    'desvalidar': [ESTADOS.FISCAL.codEstado]
  },
  'FIS':{
    'adjuntar': [ESTADOS.FISCAL.codEstado],
    'editar': [ESTADOS.FISCAL.codEstado],
    'validar': [ESTADOS.FISCAL.codEstado],
    'desvalidar': [ESTADOS.FISCAL.codEstado,ESTADOS.FACTURACION.codEstado]
  },
  'FAC':{
    'adjuntar': [ESTADOS.FACTURACION.codEstado],
    'editar': [ESTADOS.FACTURACION.codEstado],
    'validar': [ESTADOS.FACTURACION.codEstado],
    'desvalidar': [ESTADOS.FACTURACION.codEstado,ESTADOS.FACTURADO.codEstado]
  },
  'ADM':{
    'adjuntar': [ESTADOS.RESPONSABLE_AREA.codEstado,ESTADOS.FISCAL.codEstado,ESTADOS.FACTURACION.codEstado,ESTADOS.TODOS.codEstado],
    'editar': [ESTADOS.RESPONSABLE_AREA.codEstado,ESTADOS.FISCAL.codEstado,ESTADOS.FACTURACION.codEstado,ESTADOS.TODOS.codEstado],
    'validar': [ESTADOS.RESPONSABLE_AREA.codEstado,ESTADOS.FISCAL.codEstado,ESTADOS.FACTURACION.codEstado],
    'desvalidar': [ESTADOS.FISCAL.codEstado,ESTADOS.FACTURACION.codEstado,ESTADOS.FACTURADO.codEstado]
  },
}